import React, { useState, useEffect } from 'react';  
import './feedbackpage.css';  
  
const FeedbackDashboard = () => {  
    const [startDate, setStartDate] = useState('');  
    const [endDate, setEndDate] = useState('');  
    const [feedbackData, setFeedbackData] = useState([]);  
    const [isLoading, setIsLoading] = useState(false);  
    const [submittedRange, setSubmittedRange] = useState(null);  
    const [searchQuery, setSearchQuery] = useState('');  
    const [showUsername, setShowUsername] = useState(true);  
    const [showComments, setShowComments] = useState(true);  
    const [showRating, setShowRating] = useState(true);  
    const [showEmailID, setShowEmailID] = useState(true);  
  
    useEffect(() => {  
        const handleScroll = () => {  
            const footer = document.querySelector('footer');  
            if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {  
                footer.style.display = 'block';  
            } else {  
                footer.style.display = 'none';  
            }  
        };  
  
        window.addEventListener('scroll', handleScroll);  
        return () => {  
            window.removeEventListener('scroll', handleScroll);  
        };  
    }, []);  
  
    const fetchFeedbackData = async (start, end) => {  
        setIsLoading(true);  
        try {  
            const response = await fetch(`/api/feedback`, {  
                method: 'POST',  
                headers: {  
                    'Content-Type': 'application/json',  
                },  
                body: JSON.stringify({ start, end }),  
            });  
            const result = await response.json();  
            setFeedbackData(result);  
        } catch (error) {  
            console.error('Error fetching data:', error);  
        } finally {  
            setIsLoading(false);  
        }  
    };  
  
    const handleSubmitDateRange = async () => {  
        if (startDate && endDate) {  
            console.log(`Fetching feedback from ${startDate} to ${endDate}`);  
            setSubmittedRange(`${startDate} - ${endDate}`);  
            fetchFeedbackData(startDate, endDate);  
        } else {  
            alert('Please select both start and end dates.');  
        }  
    };  
  
    const handleDownloadExcel = async () => {  
        if (startDate && endDate) {  
            try {  
                const response = await fetch(`/api/fetch_details`, {  
                    method: 'POST',  
                    headers: {  
                        'Content-Type': 'application/json',  
                    },  
                    body: JSON.stringify({ startDate, endDate }),  
                });  
  
                if (!response.ok) {  
                    throw new Error('Network response was not ok');  
                }  
  
                const blob = await response.blob();  
  
                const url = window.URL.createObjectURL(blob);  
                const a = document.createElement('a');  
                a.href = url;  
                a.download = `From_${startDate}_to_${endDate}.xlsx`;  
  
                document.body.appendChild(a);  
                a.click();  
                document.body.removeChild(a);  
  
                window.URL.revokeObjectURL(url);  
  
            } catch (error) {  
                console.error('Error fetching data:', error);  
            }  
        } else {  
            alert('Please select both start and end dates.');  
        }  
    };  
  
    const filteredFeedbackData = feedbackData.filter((feedback) => {  
        const query = searchQuery.toLowerCase();  
        const name = feedback.name ? feedback.name.toLowerCase() : '';  
        const feedbackText = feedback.feedback ? feedback.feedback.toLowerCase() : '';  
        const rating = feedback.rating ? feedback.rating.toString() : '';  
        const emailID = feedback.emailID ? feedback.emailID.toLowerCase() : '';  
  
        return (  
            name.includes(query) ||  
            feedbackText.includes(query) ||  
            rating.includes(query) ||  
            emailID.includes(query)  
        );  
    });  
  
    return (  
        <>  
            <h1>Feedback Dashboard</h1>  
            <div className="container">  
                <div className="datepickercontainer">  
                    <div className="date-picker">  
                        <div className="startdate">  
                            <label htmlFor="start-date-picker">Start date:</label>  
                            <input  
                                type="date"  
                                id="start-date-picker"  
                                name="start-date-picker"  
                                value={startDate}  
                                onChange={(e) => setStartDate(e.target.value)}  
                            />  
                        </div>  
                        <div className="enddate">  
                            <label htmlFor="end-date-picker">End date:</label>  
                            <input  
                                type="date"  
                                id="end-date-picker"  
                                name="end-date-picker"  
                                value={endDate}  
                                onChange={(e) => setEndDate(e.target.value)}  
                            />  
                        </div>  
                    </div>  
                    <button onClick={handleSubmitDateRange}>Submit</button>  
                    <button onClick={handleDownloadExcel}>Download Excel</button>  
                </div>  
                {isLoading && <p>↺</p>}  
                <div className="feedbacks">  
                    <div className="feedbackscontents">  
                        <h2>Feedbacks</h2>  
                        <label htmlFor="username"></label>  
                        <input  
                            type="text"  
                            id="username"  
                            name="username"  
                            placeholder="Search"  
                            value={searchQuery}  
                            onChange={(e) => setSearchQuery(e.target.value)}  
                        />  
                        <div className="togglescreen">  
                            <label>  
                                <input  
                                    type="checkbox"  
                                    checked={showUsername}  
                                    onChange={() => setShowUsername(!showUsername)}  
                                />  
                                Show Username  
                            </label>  
                            <label>  
                                <input  
                                    type="checkbox"  
                                    checked={showComments}  
                                    onChange={() => setShowComments(!showComments)}  
                                />  
                                Show Comments  
                            </label>  
                            <label>  
                                <input  
                                    type="checkbox"  
                                    checked={showRating}  
                                    onChange={() => setShowRating(!showRating)}  
                                />  
                                Show Rating  
                            </label>  
                            <label>  
                                <input  
                                    type="checkbox"  
                                    checked={showEmailID}  
                                    onChange={() => setShowEmailID(!showEmailID)}  
                                />  
                                Show EmailID  
                            </label>  
                        </div>  
                        {submittedRange && <p>{submittedRange}</p>}  
                        <div className="table-container">  
                            <table className="feedback-table">  
                                <thead>  
                                    <tr>  
                                        {showUsername && <th>Username</th>}  
                                        {showComments && <th>Comments</th>}  
                                        {showRating && <th>Rating</th>}  
                                        {showEmailID && <th>EmailID</th>}  
                                    </tr>  
                                </thead>  
                                <tbody>  
                                    {filteredFeedbackData.length > 0 ? (  
                                                                                filteredFeedbackData.map((feedback, index) => (  
                                            <tr key={index}>  
                                                {showUsername && <td>{feedback.name}</td>}  
                                                {showComments && <td>{feedback.feedback}</td>}  
                                                {showRating && <td>{feedback.rating}</td>}  
                                                {showEmailID && <td>{feedback.emailID}</td>}  
                                            </tr>  
                                        ))  
                                    ) : (  
                                        <tr>  
                                            <td colSpan={4}>No feedback available.</td>  
                                        </tr>  
                                    )}  
                                </tbody>  
                            </table>  
                        </div>  
                    </div>  
                </div>  
                <footer>  
                    <div className="footer-content">  
                        <p></p>  
                    </div>  
                </footer>  
            </div>  
        </>  
    );  
};  
  
export default FeedbackDashboard;    
                                           